import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import Container from "components/Container/Container";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefDocuments from "table-defs/TableDefDocuments";
import UploadDocumentsModal from "./components/UploadDocumentsModal/UploadDocumentsModal";
import CreateFolderModal from "./components/CreateFolderModal/CreateFolderModal";
import DeleteFolderModal from "./components/DeleteFolderModal/DeleteFolderModal";
import ViewHistoryModal from "./components/ViewHistory/ViewHistoryModal";
import { deleteFolderAction, loadFolderContentsAction } from "store/actions/Actions";
import useFilterRows from "helpers/customHooks/useFilterRows";
import styles from "./Documents.module.scss";
import { setSelectedRows, toggleDropdowns } from "helpers/utils";
import { ONLY_OFFICE_CALLBACK_URL } from  "helpers/ApiEndpointConstants";

const Documents = props => {
    const [state, setState] = useState({
        selectedRows: null,
        parentFolder: 0,
        currentFolderName: null,
    });

    const [selectedFile, setSelectedFile] = useState(state.selectedFile);
    const {folderContents, loadFolderContentsAction, parentFolder} = props;
    
    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "last_modified",
    };
    const [filters, setFilters] = useState(noFilters);


    const [editFolder, setEditFolder] = useState(false);

    useEffect(() => {
        if (!folderContents) {
            loadFolderContentsAction({parent_folder: 0});
            // setFilter(noFilters);
        }

    }, [folderContents, parentFolder, loadFolderContentsAction, noFilters]);

    const [showUploadDocumentsModal, setShowUploadDocumentsModal] = useState(
        false
    );

    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
    const [showDocumentHistory, setShowDocumentHistory] = useState(false);

    const [showDeleteFolderModal, setDeleteFolderModal] = useState(false);
    

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const filteredRows = useFilterRows(filters, folderContents);
    const chooseActionDropdownRef = React.createRef();

    const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
    const selectedIds = selectedDocumentIds.map(item => item.id);
    const selectedFolders  = selectedDocumentIds.find( item =>  item.type === "folder" );


    return (
        <AppLayoutWrapFull
        onClick={toggleDropdowns([
            chooseActionDropdownRef
        ])}>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="UPLOAD DOCUMENTS"
                    primaryButtonHandler={() =>
                        setShowUploadDocumentsModal(!showUploadDocumentsModal)
                    }
                    secondaryButtonHandler={() => {
                        setEditFolder(false);
                        setShowCreateFolderModal(!showCreateFolderModal);
                        }
                    }
                    secondaryButtonText="CREATE FOLDER"
                    terinaryButtonText="UNAPPROVED DOCS"
                    terinaryButtonHandler={() => {
                            props.history.push("/achieve/unapproved-documents");
                        }
                    }
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    searchHandler={e => setFilters({ ...filters, text: e.target.value || "" })}
                    searchValue={filters.text}
                    chooseAction={[
                        // {
                        //     actionName: "Edit Permission Level",
                        //     actionHandler: () => setShowCreateFolderModal(true)
                        // },
                        // {
                        //     actionName: "Download Files",
                        //     actionHandler: () =>  {
                        //         if (selectedIds.length > 0){
                        //             if (selectedIds.length === 1 && state.selectedRows[0].type === 'file'){
                        //                 const link = document.createElement('a');
                        //                 link.download=state.selectedRows[0].folder_name;
                        //                 link.href = `${ONLY_OFFICE_CALLBACK_URL}Storage/Documents/${state.selectedRows[0].repository}`;
                        //                 document.body.appendChild(link);
                        //                 link.click();
                        //                 document.body.removeChild(link);
                        //             }else {
                        //                 console.log(selectedIds, state.selectedRows)
                        //             }
                        //         }
                        //     }
                                
                        //     // actionHandler: () => props.sendVendorAuditAffiliateAction(selectedAffiliateIds)
                        // },
                        {
                            actionName: "Delete Selected",
                            actionHandler: (e) => {
                                setDeleteFolderModal(!showDeleteFolderModal)
                            }
                        }
                    ]}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {showUploadDocumentsModal ? (
                    <UploadDocumentsModal
                        setShowModal={setShowUploadDocumentsModal}
                    />
                ) : null}
                {showCreateFolderModal ? (
                    <CreateFolderModal
                        setShowModal={setShowCreateFolderModal} editFolder={editFolder}
                    />
                ) : null}

                {showDeleteFolderModal && (
                    <DeleteFolderModal
                        setShowModal={setDeleteFolderModal} selectedFolder={selectedIds} parentFolder={props.parentFolder} selectedFolders={selectedFolders}
                    />
                )}

                {showDocumentHistory && (
                    <ViewHistoryModal
                        setShowModal={setShowDocumentHistory} selectedFile={selectedFile} history={props.history}
                    />
                )}

                
                <div className={styles['path']}>
                {(parentFolder && parentFolder.id !== 0) ?
                  (<div><i onClick={ () => loadFolderContentsAction({parent_folder: 0}) } className={`fal fa-folder-open ${styles['up']} ${styles['link']}`}></i> {props.parentFolder.path}</div>) :
                  (<div><i className={`fal fa-folder-open ${styles['up']}`}></i> /</div>)
                }
                </div>

                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefDocuments}
                    onChangeRowSelect={({ selectedRows }) =>
                        onChangeRowSelect({ selectedRows })
                    }
                    onRowClick={function(e) {
            
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        ){
                           
                            return;
                        }

                        if (this.props.rowData['type'] === 'folder'){
                            loadFolderContentsAction({parent_folder: this.props.rowData.id});
                            // setParentFolder(this.props.rowData.id);
                            // setCurrentFolderName(this.props.rowData.path)
                            //loadFolderContentsAction({parent_folder: this.props.rowData.id});
                        }else {
                            if (this.props.rowData['file_type'] === 'video'){
                                props.history.push(`/achieve/documents/player/${this.props.rowData.id}`);
                                return;
                            }

                            if (props.UserOrgSiteReducer.selected.is_admin || props.selected.UserOrgSiteReducer.is_super){
                                props.history.push(
                                    `/achieve/documents/editor/${this.props.rowData.id}/edit`
                                );
                            }else {
                                props.history.push(
                                    `/achieve/documents/editor/${this.props.rowData.id}/view`
                                );
                            }

                        }
                    }}
                    
                    setSelectedRows={ setSelectedRows(["id", "type"], setSelectedDocumentIds) }
                    customTableProps={{
                        onNameClick: ({ rowData }) => console.log("TODO: NAME CLICK", rowData),
                        view: ({ type, id, path }) => {
                            if (type === 'folder') {
                                // setParentFolder(id);
                                // setCurrentFolderName(path)
                                loadFolderContentsAction({parent_folder: id});
                            }else{
                                props.history.push(
                                    `/achieve/documents/editor/${id}/view`
                                );
                            }
                        },
                        edit: (rowData) => {
                            // console.log(rowData);
                            if (rowData.type === 'folder'){
                                setShowCreateFolderModal(!showCreateFolderModal)
                                setEditFolder(rowData);
                            }else{
                                console.log(rowData.file_type);
                                if (rowData.file_type === 'video'){
                                    props.history.push(`/achieve/documents/player/${rowData.id}`);
                                }else {
                                    props.history.push(`/achieve/documents/editor/${rowData.id}/edit`);
                                }
                            }
                        },
                        editFilePermissions: (rowData) => {
                            setShowCreateFolderModal(!showCreateFolderModal)
                            setEditFolder(rowData);
                        },
                        delete: rowData  => {
                            setSelectedDocumentIds([rowData]);
                            setDeleteFolderModal(!showDeleteFolderModal)
                        },
                        download: rowData => {
                            // console.log(rowData);
                            const link = document.createElement('a');
                            link.href = `${ONLY_OFFICE_CALLBACK_URL}Storage/Documents/get.php?${rowData.id}`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        },
                        upload: rowData => {
                            setShowUploadDocumentsModal(true);
                        },
                        viewHistory: rowData => {
                            setSelectedFile(rowData);
                            setShowDocumentHistory(true);
                        }
                    }}
                />
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = state => ({
    folderContents: state.FolderContentsReducer.folderContents,
    parentFolder: state.FolderContentsReducer.parentFolder,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadFolderContentsAction,
    deleteFolderAction
};

// export default Documents;
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Documents);
